import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";
import moment from "moment";
import jui from "jquery-ui";
import "jquery-ui/ui/widgets/spinner";
import "bootstrap/bootstrap-timepicker";
import "daterangepicker";

"use strict";
$.extend($.datepicker, {
    //1950:new Date().getFullYear()
    _defaults: $.extend($.datepicker._defaults, {
        yearRange: "1900:2030",
        changeMonth: true,
        changeYear: true,
        showOtherMonths: true,
        selectOtherMonths: true
    }),
    _doKeyDown: function (event) {
        //copy original source here with different
        //values and conditions in the switch statement
        var onSelect, dateStr, sel,
            inst = $.datepicker._getInst(event.target),
            handled = true,
            isRTL = inst.dpDiv.is(".ui-datepicker-rtl");

        inst._keyEvent = true;
        if ($.datepicker._datepickerShowing) {
            switch (event.keyCode) {
            case 9:
                $.datepicker._hideDatepicker();
                handled = false;
                break; // hide on tab out
            case 13:
                sel = $("td." + $.datepicker._dayOverClass + ":not(." +
                    $.datepicker._currentClass + ")", inst.dpDiv);
                if (sel[0]) {
                    $.datepicker._selectDay(event.target, inst.selectedMonth, inst.selectedYear, sel[0]);
                }

                onSelect = $.datepicker._get(inst, "onSelect");
                if (onSelect) {
                    dateStr = $.datepicker._formatDate(inst);

                    // trigger custom callback
                    onSelect.apply((inst.input ? inst.input[0] : null), [dateStr, inst]);
                } else {
                    $.datepicker._hideDatepicker();
                }

                return false; // don't submit the form
            case 27:
                $.datepicker._hideDatepicker();
                break; // hide on escape
            case 33:
                $.datepicker._adjustDate(event.target, (event.ctrlKey ?
                    -$.datepicker._get(inst, "stepBigMonths") :
                    -$.datepicker._get(inst, "stepMonths")), "M");
                break; // previous month/year on page up/+ ctrl
            case 34:
                $.datepicker._adjustDate(event.target, (event.ctrlKey ?
                    +$.datepicker._get(inst, "stepBigMonths") :
                    +$.datepicker._get(inst, "stepMonths")), "M");
                break; // next month/year on page down/+ ctrl
            case 35:
                if (event.ctrlKey || event.metaKey) {
                    $.datepicker._clearDate(event.target);
                }
                handled = event.ctrlKey || event.metaKey;
                break; // clear on ctrl or command +end
            case 36:
                if (event.ctrlKey || event.metaKey) {
                    $.datepicker._gotoToday(event.target);
                }
                handled = event.ctrlKey || event.metaKey;
                break; // current on ctrl or command +home
            case 37: //if (event.ctrlKey || event.metaKey) {
                $.datepicker._adjustDate(event.target, (isRTL ? +1 : -1), "D");
                //}
                handled = true; //event.ctrlKey || event.metaKey;
                // -1 day on ctrl or command +left
                if (event.originalEvent.altKey) {
                    $.datepicker._adjustDate(event.target, (event.ctrlKey ?
                        -$.datepicker._get(inst, "stepBigMonths") :
                        -$.datepicker._get(inst, "stepMonths")), "M");
                }
                // next month/year on alt +left on Mac
                break;
            case 38: //if (event.ctrlKey || event.metaKey) {
                $.datepicker._adjustDate(event.target, -7, "D");
                //}
                handled = true; //event.ctrlKey || event.metaKey;
                break; // -1 week on ctrl or command +up
            case 39: //if (event.ctrlKey || event.metaKey) {
                $.datepicker._adjustDate(event.target, (isRTL ? -1 : +1), "D");
                //}
                handled = true; //event.ctrlKey || event.metaKey;
                // +1 day on ctrl or command +right
                if (event.originalEvent.altKey) {
                    $.datepicker._adjustDate(event.target, (event.ctrlKey ?
                        +$.datepicker._get(inst, "stepBigMonths") :
                        +$.datepicker._get(inst, "stepMonths")), "M");
                }
                // next month/year on alt +right
                break;
            case 40: //if (event.ctrlKey || event.metaKey) {
                $.datepicker._adjustDate(event.target, +7, "D");
                //}
                handled = true; //event.ctrlKey || event.metaKey;
                break; // +1 week on ctrl or command +down
            default:
                handled = false;
            }
        } else if (event.keyCode === 36 && event.ctrlKey) { // display the date picker on ctrl+home
            $.datepicker._showDatepicker(this);
        } else {
            handled = false;
        }

        if (handled) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
});
var time_picker_with_spinner = {
    create: function (tp_inst, obj, unit, val, min, max, step) {
        $('<input class="ui-timepicker-input" value="' + val + '" style="width:50%">')
            .appendTo(obj)
            .spinner({
                min: min,
                max: max,
                step: step,
                icons: {
                    up: "fa fa-caret-up",
                    down: "fa fa-caret-down"
                },
                change: function (e) { // key events
                    // don't call if api was used and not key press
                    if (e.originalEvent !== undefined)
                        tp_inst._onTimeChange();
                    tp_inst._onSelectHandler();
                },
                spin: function (e, ui) { // spin events
                    tp_inst.control.value(tp_inst, obj, ui.value);
                    tp_inst._onTimeChange();
                    tp_inst._onSelectHandler();
                }
            });
        return obj;
    },
    options: function (tp_inst, obj, unit, opts, val) {
        if (typeof (opts) == "string" && val !== undefined)
            return obj.find(".ui-timepicker-input").spinner(opts, val);
        return obj.find(".ui-timepicker-input").spinner(opts);
    },
    value: function (tp_inst, obj, unit, val) {
        if (val !== undefined)
            return obj.find(".ui-timepicker-input").spinner("value", val);
        return obj.find(".ui-timepicker-input").spinner("value");
    }
};


ko.bindingHandlers.datepicker = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        //initialize datepicker with some optional options
        var options = allBindingsAccessor().datepickerOptions || {};
        options = $.extend({
            "showOn": "button",
            beforeShow: function () {
                let $modal_parent = $(element).closest(".modal.in");
                let dpDiv = $(element).data("datepicker").dpDiv;

                if ($modal_parent.length) {
                    $modal_parent.append(dpDiv);
                }
                // setTimeout(function () {
                //     $('.ui-datepicker').css('z-index', 99999999999999);
                // }, 0);
            },
            onSelect: function(dt) {
                console.log("OnSelect picker:", dt, arguments);
                var dt2 = $(element).datepicker("getDate");
                console.log("DAte:", dt2, " from date: ", dt);
                //need to set the observable
                var c = $(element).data("__changing");
                if (c)
                    return;
                var observable = valueAccessor();
                var value = new moment($(element).datepicker("getDate"));
                observable(value.format("YYYY-MM-DD"));
            }
            //,
            //TODO: Fix for Tarion
            //"dateFormat": "mm/dd/yyyy"
        }, options);
        $(element).datepicker(options).click(function () {
            $(element).datepicker("show");
        }).keypress(function (ev) {
            if (ev.which == 13) {
                ev.preventDefault();
                $(element).datepicker("show");
                return false;

            } else if (ev.which == 116) { // 't'
                ev.preventDefault();
                if (ko.isObservable(valueAccessor())) {
                    valueAccessor()(new Date());
                } else $(element).datepicker("setDate", new Date()).change();
            }
        }).next().hide();
        var btn = $(element).next().next(".input-group-btn").children(".btn");
        btn.click(()=>{
            var v = $(element).data("datepicker").dpDiv.is(":visible");;
            $(element).datepicker(v ? "hide" : "show");
        });
        $(element).data("__changing", false);

        //handle the field changing
        ko.utils.registerEventHandler(element, "change", function () {
            var c = $(element).data("__changing");
            if (c)
                return;
            var observable = valueAccessor();
            var value = new moment($(element).datepicker("getDate"));
            observable(value.format("YYYY-MM-DD"));
        });

        //handle disposal (if KO removes by the template binding)
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            $(element).datepicker("destroy");
        });

    },
    update: function (element, valueAccessor) {
        var value = ko.unwrap(valueAccessor());
        if (typeof value == "string") {
            value = new Date(value);
        }

        $(element).data("__changing", true);
        $(element).datepicker("setDate", value);
        $(element).data("__changing", false);
    }
};

ko.bindingHandlers.datetimepicker = {
    init: function (element, valueAccessor, allBindingsAccessor) {

        if (uly.utils.is_mobile())
            $(element).attr({
                "readonly": "readonly"
            });

        //initialize datepicker with some optional options
        var options = allBindingsAccessor().datepickerOptions || {}; //dateFormat: "dd/mm/yy" };
        options = $.extend({}, {}, options);
        var use_slider = $(element).data("slider") || false;
        if (!use_slider)
            options = $.extend({
                "showOn": "button",
                "controlType": time_picker_with_spinner
            }, options);
        else
            options = $.extend({
                "showOn": "button"
            }, options);

        options = $.extend({
            beforeShow: function () {
                let $modal_parent = $(element).closest(".modal.in");
                let dpDiv = $(element).data("datepicker").dpDiv;

                if ($modal_parent.length) {
                    $modal_parent.append(dpDiv);
                }

                setTimeout(function () {
                    $('.ui-datepicker').css('z-index', 99999999999999);
                }, 0);
            },
            onSelect: function(dt) {
                setTimeout(function() {
                var new_date = $(element).datetimepicker("getDate");
                //need to set the observable
                var c = $(element).data("__changing");
                if (c)
                    return;
                var observable = valueAccessor();
                $(element).data("__changing", true);
                try {
                    observable(new_date);
                } finally {
                    $(element).data("__changing", false);
                }
                }, 0);
            }
        }, options);
        var btn = $(element).next(".input-group-btn").children(".btn");

        $(element).datetimepicker(options).click(function () {
            $(element).datetimepicker("show");
        }).keypress(function (ev) {
            if (ev.which == 13) {
                ev.preventDefault();
                $(element).datetimepicker("show");
                return false;

            } else if (ev.which == 116) { // 't'
                ev.preventDefault();
                if (ko.isObservable(valueAccessor())) {
                    valueAccessor()(new Date());
                } else $(element).datetimepicker("setDate", new Date()).change();
            }
        }).next().hide();

        $(element).data("__changing", false);
        //handle the field changing
        ko.utils.registerEventHandler(element, "change", function () {
            var observable = valueAccessor();
            var c = $(element).data("__changing");
            if (c)
                return;
            var new_date = $(element).datetimepicker("getDate");
            $(element).data("__changing", true);
            try {
                observable(new_date);
            } finally {
                $(element).data("__changing", false);
            }
        });
        btn.click(() => {
            var v = $(element).data("datepicker").dpDiv.is(":visible");;
            $(element).datetimepicker(v ? "hide": "show");
        });


        //handle disposal (if KO removes by the template binding)
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            $(element).datetimepicker("destroy");
        });
        //force an update now?
        valueAccessor().notifySubscribers();
        return true;
    },
    update: function (element, valueAccessor) {
        var value = ko.unwrap(valueAccessor());
        var c = $(element).data("__changing");
        if (c)
            return;
        $(element).data("__changing", true);
        try {
            if (typeof value == "string") {
                value = new Date(value);
            }
            console.log("updating datepicker with value", value);
            $(element).datetimepicker("setDate", value);
        } finally {
            $(element).data("__changing", false);
        }
    }
};
ko.bindingHandlers.timepicker = {
    init: function (element, valueAccessor) {
        $(element).timepicker({
            icons: {
                up: "fa fa-caret-up",
                down: "fa fa-caret-down"
            },
            defaultTime: ko.unwrap(valueAccessor())
        });
        var tp = $(element).data("timepicker");
        ko.utils.registerEventHandler(element, "change", function () {
            if ($(element).data("__changing"))
                return;

            var observable = valueAccessor();
            var c = $(element).data("__changing");
            if (c) return;


            var val = tp.getTime();
            console.log("Got val:", val, ko.unwrap(observable));
            if (val && typeof val === "string") {
                val = new moment(val, ["h:m a", "h:m A", "hh:mm a", "hh:mm A", "H:m", "HH:mm"]).format("HH:mm:ss");
            }
            $(element).data("__changing", true);
            try {
                console.log("setting observable to: ", val);
                observable(val);
            } finally {
                $(element).data("__changing", false);
            }
        });
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            //NO Destroy method on timepicker
            //$(element).timepicker("destroy");
        });

    },
    update: function (element, va) {
        var newvalue = ko.unwrap(va());
        var tp = $(element).data("timepicker");
        if ($(element).data("__changing"))
            return;
        $(element).data("__changing", true);
        try {
            console.log("Setting time:", newvalue);
            tp.setTime(newvalue);
        } finally {
            $(element).data("__changing", false);
        }
    }
};


ko.bindingHandlers.daterangepicker = {
    init: function (elt, va) {
        $(elt).daterangepicker();
        $(elt).on("apply.daterangepicker", function (ev, picker) {
            var vobs = va();
            if (ko.isObservable(vobs)) {
                var dt1 = picker.startDate;
                var dt2 = picker.endDate;
                if (dt1 == dt2)
                    vobs([null, null]);
                else
                    vobs([picker.startDate, picker.endDate]);
            }
        });
    },
    update: function (elt, va) {
        var vals = ko.unwrap(va());
        var picker = $(elt).data("daterangepicker");
        if (vals) {
            picker.setStartDate(vals[0] || new Date());
            picker.setEndDate(vals[1] || picker.startDate);
        } else {
            var dt = picker.startDate || new Date();
            picker.setStartDate(dt);
            picker.setEndDate(dt);
        }
    }
};
